<template>
  <span class="tr-pill" :class="`tr-pill-${status}`">
    <fa-icon :icon="['fal', icon]" v-if="icon"/>{{ label }}
  </span>
</template>

<script>
import { getName, icons } from '@/data/billing-transfer-statuses';

export default {
  props: {
    status: {
      type: String,
      required: true,
    },
  },
  computed: {
    label() {
      return getName(this.status) || this.status;
    },
    icon() {
      return icons[this.status] || null;
    },
  },
};
</script>
